import React from "react";
import { Body, Main } from "./styles"

export default props => {
    return (
        <Body>
            <Main className={props.hasError && 'error'} disabled={props.disabled}>
                <label htmlFor={props.id} >{props.labelText}</label>
                <textarea
                    id={props.id}
                    name={props.name}
                    value={props.value || ""}
                    rows={props.rows}
                    cols={props.cols}
                    readOnly={props.readOnly}
                    onChange={props.onChange}
                    onKeyUp={props.onKeyUp}
                    onBlur={props.onBlur}
                    disabled={props.disabled}
                    maxLength={props.maxLength}
                />
            </Main>
            <span 
                className={
                    `span-display
                    ${props.hasError ? "span-display-block span-display-error" : " "}`
                }
            >
                {props.hasError ? props.error : " "}
            </span>
        </Body>
    )
}